import { RestSlice } from '../../../../redux/rest.slice';
import { IppAuditLog } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippAuditLogSlice = new RestSlice<IppAuditLog>(
	localizationService.getLocalizedString('ipp.auditLog.auditLogs'),
	Resource.IppAuditLogs
);
export default ippAuditLogSlice.rests.reducer;
